import Widget from '../classes/widget';
import SignupFormWidget from '../classes/signup-form-widget';

export default {
	SIGNUP_FORM: SignupFormWidget
};



// WEBPACK FOOTER //
// ./src/main/webapps/features/stickybins/scripts/public/constants/widgets.js